import React, { FC, SVGAttributes } from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';

// NOTE -  we have used a custom scss for this component , file name is : button-common.scss

export type IconTypeData = FC<IconProps>;

interface CentralizeButtonProps {
  text?: string;
  icon?: IconTypeData; // Icon to be rendered
  className?: string;
  href?: string;
  size?: 'md' | 'sm' | 'lg';
  active?: boolean;
  'aria-label'?: string;
  block?: boolean;
  color?:
    | 'primary'
    | 'secondary'
    | 'dark'
    | 'success'
    | 'error'
    | 'warning'
    | 'info'
    | 'gradient'
    | 'white';
  iconColor?: string;
  disabled?: boolean;
  outline?: boolean;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  target?: string;
  type?: string;
  isIconLeftSide?: boolean;
  iconClassNames?: string;
  iconSize?: string;
  styleIcon?: React.CSSProperties;
  iconFill?: string;
}

export interface IconProps extends SVGAttributes<SVGElement> {
  color?: string;
  size?: string | number;
}

const CentralizeButton: React.FC<CentralizeButtonProps> = ({
  text,
  className,
  icon: Icon,
  iconClassNames,
  size = 'md',
  color = 'primary',
  iconColor = undefined,
  outline,
  isIconLeftSide = false,
  iconSize, // Default icon size
  onClick,
  styleIcon,
  iconFill,
  ...props
}) => {
  const propsData =
    color === 'gradient' && outline ? { ...props, data: text } : { ...props };
  const iconSizeData = iconSize || getIconSize(size);
  const iconProps = iconFill ? { fill: iconFill } : {};

  const buttonClasses = classNames({
    custom: true,
    [`btn-custom-${size}`]: true,
    [`btn-custom-${color}`]: true,
    [`btn-custom-outline-${color}`]: outline,
    'btn-custom-icon': !!Icon,
    [`btn-custom-icon-direction-${isIconLeftSide ? 'left' : 'right'}`]: true,
  });

  const iconClasses = classNames(iconClassNames, {
    'btn-custom-icon-data': true,
    [`btn-custom-icon-${isIconLeftSide ? 'left' : 'right'}`]: true,
  });

  return (
    <Button
      onClick={onClick}
      className={className}
      color={buttonClasses}
      {...propsData}
    >
      {isIconLeftSide && Icon && (
        <Icon
          color={iconColor || undefined}
          style={styleIcon}
          className={iconClasses}
          size={parseInt(iconSizeData, 10)}
          {...iconProps}
        />
      )}

      {color === 'gradient' && outline ? (
        <></>
      ) : (
        <>
          <span>{text}</span>
        </>
      )}

      {!isIconLeftSide && Icon && (
        <Icon
          color={iconColor || undefined}
          style={styleIcon}
          className={iconClasses}
          size={parseInt(iconSizeData, 10)}
          {...iconProps}
        />
      )}
    </Button>
  );
};

function getIconSize(btnSize: string) {
  if (btnSize === 'lg') {
    return '22';
  }
  if (btnSize === 'sm') {
    return '14';
  }

  return '16';
}

export default CentralizeButton;
